import { Agent } from "./Agent"
import { Call } from "./Call"
import { User } from "./User"

export interface State {
  user?: User
  audioEnabled: boolean
  videoEnabled: boolean
  audioDevice?: string
  videoDevice?: string
  stream?: MediaStream
  call: Call
  agent: Agent
}

export enum StateAction {
  setUser = "setUser",
  end = "end",
  toggleAudio = "toggleAudio",
  toggleVideo = "toggleVideo",
  setAudioDevice = "setAudioDevice",
  setVideoDevice = "setVideoDevice",
  setStream = "setStream",
  setCall = "setCall",
  setAgent = "setAgent",
  resetAgentAndCall = "resetAgentAndCall",
  resetState = "resetState",
}

export type Action =
  | { type: StateAction.setUser; payload: User }
  | { type: StateAction.end }
  | { type: StateAction.toggleAudio }
  | { type: StateAction.toggleVideo }
  | { type: StateAction.setAudioDevice; payload: string }
  | { type: StateAction.setVideoDevice; payload: string }
  | { type: StateAction.setStream; payload: MediaStream }
  | { type: StateAction.setCall; payload: Call }
  | { type: StateAction.setAgent; payload: Agent }
  | { type: StateAction.resetAgentAndCall }
  | { type: StateAction.resetState }
